import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import Icon from "../../../common/icon/icon.component.jsx";
import InvoiceStatusBadge from "../../../invoice/status.component.jsx";

class ReturnFromInvoiceCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            invoice: this.props.invoice || null,
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
            invoice: nextProps.invoice || null,
        })
    }

    render() {

        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <p className={'mb-0'}>
                    <FormattedMessage
                        id="quote.analytics.events.return_invoice_created.text"
                        defaultMessage="The return {ret} has been created from the invoice {invoice}"
                        values={{
                            ret: <strong>
                                <Link to={'/returns/' + this.state.object.id + '/edit'}>
                                    {this.state.object.attributes.identifier}
                                </Link>
                            </strong>,
                            invoice: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
                     <InvoiceStatusBadge status={this.state.object.attributes.status} className={'ml-2'} />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-5'}>
                    <h3 className={"m-0"}>
                        <Icon value={"invoice"} />
                    </h3>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.invoice_created.total_amount"
                                    defaultMessage="Total amount"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        <FormattedNumber
                            value={this.state.object.attributes.totalAmount}
                            style={'currency'}
                            currency={this.state.object.attributes.currency}
                        />
                    </h4>
                </div>
            </div>
        </div>
    }

}

export default ReturnFromInvoiceCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/return-from-invoice-created.component.jsx